// ============================================================
// KORA DIGITAL — Moitte tracking events
// Activado: Junio 2026
// Eventos: Meta Pixel + Klaviyo via hooks nativos del tema Lorenza
// ============================================================

// AddToCart — dispara cuando el usuario añade un producto al carrito
// Fuente única de verdad: este archivo. Monster Cart tiene disable_klaviyo_tracking: true
document.addEventListener("flu:cart:item-added", function (evt) {
  var product = evt.detail.product;
  if (!product) return;

  var productId = product.id ? product.id.toString() : '';
  var productTitle = product.title || '';
  var productPrice = product.price ? (product.price / 100) : 0;
  var productUrl = product.url ? (window.location.origin + product.url) : window.location.href;
  var productImage = product.featured_image || '';
  var variantId = product.variant_id ? product.variant_id.toString() : productId;

  // --- Meta Pixel AddToCart ---
  if (typeof fbq === 'function') {
    fbq('track', 'AddToCart', {
      content_ids: [variantId],
      content_name: productTitle,
      content_type: 'product',
      value: productPrice,
      currency: 'EUR'
    });
  }

  // --- Klaviyo Added to Cart ---
  var _learnq = window._learnq = window._learnq || [];
  _learnq.push(['track', 'Added to Cart', {
    $value: productPrice,
    AddedItemProductName: productTitle,
    AddedItemProductID: productId,
    AddedItemSKU: product.sku || '',
    AddedItemCategories: product.type ? [product.type] : [],
    AddedItemImageURL: productImage,
    AddedItemURL: productUrl,
    AddedItemPrice: productPrice,
    AddedItemQuantity: product.quantity || 1
  }]);
});

// Cart updated — dispara cuando el carrito cambia (cantidad, eliminación, etc.)
document.addEventListener("flu:cart:updated", function (evt) {
  // Reservado para futuros eventos de carrito
});

// Cart error
document.addEventListener("flu:cart:error", function (evt) {
  // Reservado
});

// Quick cart opened
document.addEventListener("flu:quick-cart:open", function (evt) {
  // Reservado
});

// Quick cart closed
document.addEventListener("flu:quick-cart:close", function () {
  // Reservado
});

// Variant changed — útil para tracking de ViewContent al cambiar variante
document.addEventListener("flu:product:variant-change", function (evt) {
  // Reservado — se puede añadir fbq ViewContent aquí si se necesita
});

// Quantity update
document.addEventListener("flu:product:quantity-update", function (evt) {
  // Reservado
});

// Quickview loaded
document.addEventListener("quickview:loaded", function () {
  // Reservado
});
